import { UserCircle } from '@phosphor-icons/react';
import { FontSizeControl } from './FontSizeControl';

/** Shared phone controls keep customer and staff text sizes consistent. */
export function MobileHeaderControls({ onAccount, disabled = false }: {
  onAccount: () => void;
  disabled?: boolean;
}) {
  return <div className="mobile-header-actions">
    <FontSizeControl variant="buttons" />
    <button type="button" className="mobile-account-toggle" onClick={onAccount} disabled={disabled} aria-label="账号设置">
      <UserCircle /><span>账号</span>
    </button>
  </div>;
}
